<template>
  <div class="card">
    <div
      v-if="item"
      :class="cardClass"
      @click="onClick"
      :style="isActive ? 'background-color: ' + primary : ''"
    >
      <div
        class="card-content__img"
        :style="{
          background: `linear-gradient(135deg, ${event} 0%,${primary} 50%,${secondary} 100%)`
        }"
      >
        <img :src="item.image" :alt="item.name" v-if="item.image" />
      </div>
      <div class="card-content__title">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-box",
  props: {
    item: {
      type: [Object],
      default: null
    },
    active: {
      type: [Number],
      default: -1
    }
  },
  computed: {
    cardClass() {
      return this.active === this.item.id
        ? "card-content card-content__active"
        : "card-content";
    },
    isActive() {
      return this.active === this.item.id;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    }
  },
  methods: {
    onClick() {
      this.$emit("cardclick", this.item.id);
    },
    openModalBooking() {
      this.$emit("proceedProduct", { id: this.item.id });
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 15px;
  &-content {
    transition: all 0.2s;
    cursor: pointer;
    width: 100%;
    padding: 20px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    box-shadow: 0 3px 15px 0px rgba(0, 0, 0, 0.1);
    margin-right: 20px;
    &__img {
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      height: 200px;
      overflow: hidden;
      width: 100%;
      img {
        width: 100%;
        object-fit: cover;
        height: 200px;
      }
    }
    &__title {
      text-align: center;
      padding: 30px 0;
      line-height: 24px;
      font-size: 16px;
    }
    &__active {
      background-color: $gray-500;
      color: white;
    }
    &:hover {
      background-color: $gray-400;
      color: white;
    }
  }
}
</style>
